import { render, staticRenderFns } from "./PermanentJobBooking.vue?vue&type=template&id=4fad2d12&scoped=true"
import script from "./PermanentJobBooking.vue?vue&type=script&lang=ts"
export * from "./PermanentJobBooking.vue?vue&type=script&lang=ts"
import style0 from "./PermanentJobBooking.scss?vue&type=style&index=0&id=4fad2d12&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fad2d12",
  null
  
)

export default component.exports